module.exports = __webpack_public_path__ + "static/media/white-arrow.ebca71e6.svg";